import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import BootstrapVue from 'bootstrap-vue';
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueScrollTo from 'vue-scrollto'
import VueRellax from 'vue-rellax'
// import LottieAnimation from 'lottie-vuejs'
 

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);
Vue.use(VueScrollTo);
Vue.use(VueRellax);
// Vue.use(LottieAnimation);



Vue.config.productionTip = false;
Vue.config.lintOnSave = false;

new Vue({
	created(){
		AOS.init()
	},
  router,
  store,
  render: h => h(App)
}).$mount("#app");
